import React from 'react';
import {useAppSettings} from "./Comp/hooks/useAppSettings";
import App from "./App";
import Maintenance from "./Comp/Maintainnence";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentVersion} from "./store/features/UserSlice";

const MaintenanceCheck = () => {
    const {
        currentVersion
    } = useSelector(state => state.user);
    const dispatch = useDispatch();

    const {data: generalData} = useAppSettings({
        page: "general"
    }, {
        refetchOnWindowFocus: true
    });

    if (generalData?.latestversion !== undefined && (currentVersion === undefined || generalData?.latestversion !== currentVersion)) {
        console.log("Latest Version");
        dispatch(setCurrentVersion({currentVersion: generalData?.latestversion}))
        window.location.reload();
    }

    if (`${generalData?.maintainencemode}` === `1`) {
        return <Maintenance/>
    } else {
        return <App/>
    }
};

export default MaintenanceCheck;
